import { useState } from "react";
import { AllLogoIcon } from "../../common/icons";
import { LoginRedirect } from "../../services/api.login";

export default function AllLoginNotification({ languages }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    setIsLoading(true);
    await LoginRedirect();
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <span className="font-montserrat">
        {languages.redirecting ? languages.redirecting : "Redirecting..."}
      </span>
    );
  }

  let notificationParagraph = languages.loginNotification
    ? languages.loginNotification
    : "Already an ALL member? Log in to automatically complete this form and use your points to pay for your subscription.";

  // Extract the text before and after the login button
  const loginText = languages.pwpLoginButton ? languages.pwpLoginButton : "Log in";
  const modifiedText = notificationParagraph.replace(loginText, "").trim();

  return (
    <div className="flex flex-col rounded-md w-full bg-[#EAEDF5] p-4 pb-3 font-medium font-montserrat gap-2">
      <AllLogoIcon />
      <p className="font-normal text-[#3D4892] text-unde text-sm">
      {modifiedText.split("?")[0]}?{" "}
        <span className="underline cursor-pointer" onClick={handleLogin}>
          {loginText}
        </span>{" "}
        {modifiedText.split("?")[1]}
      </p>
    </div>
  );
}
